import { createTheme as createMuiTheme } from '@mui/material';
import { useMemo } from 'react';
import createThemeComponents from './createThemeComponents';
import { darkPalette, lightPalette } from './palette';

enum AppFonts {
  BricolageGrotesque = 'Bricolage Grotesque',
  Inter = 'Inter',
}

const primaryFont = [AppFonts.BricolageGrotesque, 'sans-serif'].join(',');
const secondaryFont = [AppFonts.Inter, 'sans-serif'].join(',');

const useCreateTheme = (prefersDark: boolean) => {
  const palette = prefersDark ? darkPalette : lightPalette;

  // Create base theme

  const baseTheme = useMemo(
    () =>
      createMuiTheme({
        palette,
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 1024,
            lg: 1280,
            xl: 1440,
          },
        },
        typography: {
          // fontFamily: ['Inter', 'sans-serif'].join(','),
          fontFamily: secondaryFont,
          h1: {
            fontFamily: primaryFont,
          },
          h2: {
            fontFamily: primaryFont,
          },
          h3: {
            fontFamily: primaryFont,
          },
          h4: {
            fontFamily: primaryFont,
          },
          h5: {
            fontFamily: primaryFont,
          },
          h6: {
            fontFamily: primaryFont,
          },
          body1: {
            fontSize: '16px',
            fontWeight: 400,
          },
          body2: {
            fontSize: '14px',
            fontWeight: 400,
          },
          caption: {
            fontSize: '14px',
            fontWeight: 600,
            color: '#000000',
          },
          subtitle1: {
            fontSize: '18px',
            fontWeight: 500,
          },
          subtitle2: {
            fontSize: '12px',
            fontWeight: 700,
            color: '#242A42',
          },
        },
      }),
    [prefersDark]
  );

  // const baseTheme = createMuiTheme({
  //   palette,
  // });

  // Inject base theme to be used in components
  return createMuiTheme(
    {
      // components: createThemeComponents(baseTheme) as any,

      components: createThemeComponents() as any,
    },
    baseTheme
  );
};

export default useCreateTheme;
